import React from "react"
import { useTranslation } from "@zestia/gatsby-plugin-react-i18next"

import Capterra from "@/components/svg/awards/Capterra"
import SoftwareAdvice from "@/components/svg/awards/SoftwareAdvice"
import GetApp from "@/components/svg/awards/GetApp"

const ComparisonAwards = ({}) => {
  const { t } = useTranslation()

  return (
    <section>
      <div className="container-fluid">
        <div className="col-xs-12 comparison-awards__container">
          <div className="col-md-6 comparison-awards__logos">
            <Capterra />
            <SoftwareAdvice />
            <GetApp />
          </div>
          <div className="col-md-6">
            <p className="h4">
              <strong>{t("comparison.awards.title")}</strong>
            </p>
            <p className="p--xs">{t("comparison.awards.text")}</p>
          </div>
        </div>
      </div>
    </section>
  )
}

export default ComparisonAwards
